const baseURL = "/v1/Disciplina";

const service = {
  methods: {
    $buscarTipoDeDisciplina() {
      return this.$api().get(`${baseURL}/TipoDisciplina`);
    },
    $buscarDisciplina(params) {
      return this.$api().get(`${baseURL}`, params);
    },
    $visualizarDisciplina(id) {
      return this.$api().get(`${baseURL}/${id}`);
    },
    $cadastrarDisciplina(body) {
      return this.$api().post(`${baseURL}`, body);
    },
    $editarDisciplina(id, body) {
      return this.$api().put(`${baseURL}/${id}`, body);
    },
    $inativarAtivarDisciplina(id) {
      return this.$api().patch(`${baseURL}/${id}`, {});
    },
    $excluirDisciplina(id) {
      return this.$api().delete(`${baseURL}/${id}`);
    },
    $detalharUsoDisciplina({ id, params}) {
      return this.$api().get(`${baseURL}/DetalharUso/${id}`, params);
    },
  },
};

export default service;